var React = require('react');

function CubeIcon (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"cube-icon"),React.createElement("g",{"id":"Layer_2","data-name":"Layer 2","key":1},React.createElement("g",{"id":"Layer_1-2","data-name":"Layer 1"},React.createElement("path",{"id":"Path_1","data-name":"Path 1","d":"M1.47,14.83V6l7,3.89v8.84ZM10,9.88,17,6v8.84l-7,3.89ZM6.77,7.22,2.37,4.79,9.23,1.65,16.1,4.79,11.7,7.22,9.24,8.59ZM1.44,3.57l-1,.48L0,4.25V15.71l3.48,1.93,5.43,3h0l.36.2.36-.2h0l5.42-3,3.45-1.93V4.25l-.43-.2-1-.48L9.24,0Z","style":{"fill":"#1c1c1c"}})))]);
}

CubeIcon.defaultProps = {"viewBox":"0 0 18.5 20.84"};

module.exports = CubeIcon;

CubeIcon.default = CubeIcon;
